import {Component, Inject, ViewChild} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {HttpService, SnackbarService} from '../../core';
import { environment as env } from '../../../environments/environment';
import { GeneralService } from '../../core';
import { SettingsProvider } from '../../core';
import {ProductsDataService} from '../../domain/products/services/products.data.service';
import {Observable} from 'rxjs';

export interface DialogData {
    contractId: number;
}

@Component({
    selector: 'create-price-contract-dialog',
    templateUrl: 'delete-price-contract-dialog.component.html',
    styleUrls: ['delete-price-contract-dialog.component.scss'],
})


export class DeletePriceContractDialogComponent {
    deleting = false;
    productId = 0;

    constructor(
        public snackBar: SnackbarService,
        public dialogRef: MatDialogRef<DeletePriceContractDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public generalService: GeneralService,
        public settingsService: SettingsProvider,
        public dataService: ProductsDataService,
        private http: HttpService,
    ) {}

    close(): void {
        this.dialogRef.close();
    }

    onNoClick(): void {
        this.dialogRef.close({ confirm: false });
    }

    confirmFromDialog(): void {
        this.dialogRef.close({ confirm: true });
    }

    deletePriceContract(): Observable<any> {
        const url = `${this.settingsService.configuration.url}${env.PriceContractDataService.apiUrlDelete}/${this.data.contractId}`;
        return this.http.delete(url);
    }

    deletePriceContractClick(): void {
        this.deleting = true;
        this.deletePriceContract().subscribe(
            () => {
                this.dialogRef.close({ confirm: true })
                this.snackBar.info("Udało się usunąć kontrakt cenowy");
            },
            logErr => {
                this.snackBar.info("Nie udało się usunąć kontraktu cenowego");
                this.deleting = false;
            },
            () => this.deleting = false
        );
    }
}
